/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

export type ComplementInseePartenaire = {
  etatMatrimonialCode?: string | null;
  dateDivorce?: string | null;
  dateVeuvage?: string | null;
  dejaPacse?: string | boolean | null;
  nombreEnfants?: number | null;
};

// Informations INSEE d'un partenaire : obligatoires sauf pour un projet de PACS
// (contrôle à la charge de l'appelant). Le nombre d'enfants en commun n'est
// saisi que sur le partenaire 1.
const validationComplementInsee = (
  complementInsee: ComplementInseePartenaire,
  avecNombreEnfants: boolean,
) => {
  const {
    etatMatrimonialCode,
    dateDivorce,
    dateVeuvage,
    dejaPacse,
    nombreEnfants,
  } = complementInsee ?? {};

  const errors = {
    etatMatrimonial: '',
    dateEtatMatrimonial: '',
    dejaPacse: '',
    nombreEnfants: '',
  };

  if (_.isEmpty(etatMatrimonialCode)) {
    errors.etatMatrimonial = "L'état matrimonial antérieur est obligatoire";
  }

  if (etatMatrimonialCode === 'D' && _.isEmpty(dateDivorce)) {
    errors.dateEtatMatrimonial = 'La date du divorce est obligatoire';
  }

  if (etatMatrimonialCode === 'V' && _.isEmpty(dateVeuvage)) {
    errors.dateEtatMatrimonial = 'La date du veuvage est obligatoire';
  }

  if (_.isNil(dejaPacse) || dejaPacse === '') {
    errors.dejaPacse = 'Il faut indiquer si le partenaire a déjà été pacsé';
  }

  if (avecNombreEnfants && _.isNil(nombreEnfants)) {
    errors.nombreEnfants = "Le nombre d'enfants en commun est obligatoire";
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationComplementInsee;
